module.exports = __webpack_public_path__ + "media/assets/icons/minus-e42bd516b4f0f400c5fe90dffb0757ca.svg";